import React from 'react';
const NotificationBadge = ({
  count
}) => {
  if (!count) return null;
  return <div className="absolute -top-1 -right-1 flex items-center justify-center">
      <div className="w-5 h-5 bg-pink-500 rounded-full flex items-center justify-center text-xs font-bold">
        {count > 9 ? '9+' : count}
      </div>
    </div>;
};
export default NotificationBadge;